import { BehaviorSubject as CommonBehaviorSubject } from "packages/rxjs";

export class BehaviorSubject<T> extends CommonBehaviorSubject<T> {}
